export const initRunningCards = (element) => {
    if (!element)
        return;
    const wrapper = element.querySelector('.running-line__wrapper');
    if (!wrapper)
        return;
    wrapper.innerHTML += wrapper.innerHTML;
    const DEFAULT_SPEED = 1;
    let position = 0;
    let speed = DEFAULT_SPEED;
    element.addEventListener('mouseenter', () => {
        speed = DEFAULT_SPEED / 2;
    });
    element.addEventListener('mouseleave', () => {
        speed = DEFAULT_SPEED;
    });
    const animate = () => {
        position -= speed;
        if (Math.abs(position) >= wrapper.scrollWidth / 2) {
            position = 0;
        }
        wrapper.style.transform = `translateX(${position}px)`;
        requestAnimationFrame(animate);
    };
    animate();
};
document.querySelectorAll('.running-line').forEach((el) => {
    initRunningCards(el);
});
